module.exports = __webpack_public_path__ + "media/login-page-bg-rzd-1366.1f305673.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/login-page-bg-rzd-1366.jpg
// module id = 1255
// module chunks = 58